import './decode';

import {createApp} from 'vue';

import TheMainApp from './components/the-main-app.vue';

createApp(TheMainApp).mount('#root');
